import React from "react";
import { CarOutlined } from "@ant-design/icons";

const { Tooltip, Tag } = require("antd");

const VehicleDamagedTag = () => {
  return (
    <Tooltip color="#fff" title="A shipment with a vehicle which has been damaged while in transit.">
      <Tag color="error">
        <CarOutlined /> Vehicle Damaged
      </Tag>
    </Tooltip>
  );
};

export default VehicleDamagedTag;
